import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadTopBlueCarHCSliderMap,
} from '@wkda/marketing-components';
import {
  ConversationalLeadTitle,
  defaultFlowWithoutConsent,
} from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      form={defaultFlowWithoutConsent}
      content={CarleadTopBlueCarHCSliderMap}
      showTrustPilot={true}
      blue={true}
      titleComponent={ConversationalLeadTitle}
      modeToggleClassName={null}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
